import { IconIds } from '@jfs/ui-new'

export interface TabbarProps {
  titles: Array<TabData>
  onSelected: (index: number) => void
  default: number
  type?: TabbarType
  hide?: boolean
  disabled?: boolean
  onLayout?: any
  onLayoutOnlyForPosition?: number
}

export enum TabbarType {
  default = 'default',
  highlights = 'highlights',
  recentPayments = 'recentPayments',
  profile = 'profile',
  bulkEntity = 'bulkEntity',
  documentation = 'documentation',
}

export interface TabData {
  title: string
  iconId?: typeof IconIds
}
